import DataTable from 'react-data-table-component';
import { translate } from 'react-switch-lang';
import { DeleteButtonIcon } from 'src/component/Buttons/DeleteButtonIcon';
import { EditButtonIcon } from 'src/component/Buttons/EditButtonIcon';
import { InfoButtonIcon } from 'src/component/Buttons/InfoButtonIcon';

const DeviseColumns = (props) => {
  const deviseColumns = [
    {
      name: props.t('devise_name'),
      selector: (row) => row.name,
      sortable: true,
      center: true,
    },
    {
      name: props.t('devise_code'),
      selector: (row) => row.code,
      sortable: true,
      center: true,
    },
    {
      id: 'Action',
      name: props.t('actions'),
      selector: (row) => row.action,
      sortable: false,
      center: true,
      cell: (row) => (
        <div>
          <InfoButtonIcon onClick={() => props.onDetail(row)} title={props.t('more_details')} />
          <EditButtonIcon onClick={() => props.onEdit(row)} title={props.t('edit_devise')} />
          <DeleteButtonIcon onClick={() => props.onDelete(row)} title={props.t('delete_devise')} />
        </div>
      ),
    },
  ];

  return <DataTable columns={deviseColumns} data={props.data} />;
};

export default translate(DeviseColumns);
